import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "./Base/baseApiModel";

export const emailCampaignApi = createApi({
    reducerPath: "emailCampaignApi",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl + "EmailCampaign",
        credentials: 'include',
        mode: "cors",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("token");
            token && headers.append("Authorization", "Bearer " + token);
            return headers;
        }
    }),
    tagTypes: ["EmailCampaign"],
    endpoints: (builder) => ({
        // Kampanya başlatma
        startCampaign: builder.mutation({
            query: (recipients) => ({
                url: '/start-campaign',
                method: 'POST',
                body: recipients
            }),
            invalidatesTags: ['EmailCampaign']
        }),
        
        // Tüm kampanyaları listele
        getEmailReports: builder.query({
            query: () => ({
                url: '/reports',
                method: 'GET'
            }),
            providesTags: ['EmailCampaign']
        }),
        
        // Belirli kampanya detayı
        getEmailReportDetails: builder.query({
            query: (campaignId) => ({
                url: `/reports/${campaignId}`,
                method: 'GET'
            }),
            providesTags: (result, error, campaignId) => [{ type: 'EmailCampaign', id: campaignId }]
        }),
        
        // Kampanya durumu
        getCampaignStatus: builder.query({
            query: (campaignId) => ({
                url: `/status/${campaignId}`,
                method: 'GET'
            }),
            providesTags: (result, error, campaignId) => [{ type: 'EmailCampaign', id: campaignId }]
        }),
        
        // Kampanya logları
        getCampaignLogs: builder.query({
            query: ({ campaignId, limit = 50 }) => ({
                url: `/logs/${campaignId}?limit=${limit}`,
                method: 'GET'
            }),
            providesTags: (result, error, { campaignId }) => [{ type: 'EmailCampaign', id: campaignId }]
        }),
        
        // Kampanyayı tamamla
        completeCampaign: builder.mutation({
            query: (campaignId) => ({
                url: `/complete/${campaignId}`,
                method: 'PUT'
            }),
            invalidatesTags: (result, error, campaignId) => [
                { type: 'EmailCampaign', id: campaignId },
                'EmailCampaign'
            ]
        })
    })
});

export const {
    useStartCampaignMutation,
    useGetEmailReportsQuery,
    useGetEmailReportDetailsQuery,
    useGetCampaignStatusQuery,
    useGetCampaignLogsQuery,
    useCompleteCampaignMutation
} = emailCampaignApi;
